import AlgoliaSearchBox from '../../../../../components/AlgoliaSearchBox';
import { EXPLORE } from '../../../../../utils/constants/SearchAnalyticsConstants';
import { LanguageSupportUtil } from '../../../../../utils/language_support_util';

const createReactClass = require('create-react-class');

const FullscreenBreadcrumbBar = createReactClass({
  render() {
    const bullet = <span>&nbsp; &#8226; &nbsp;</span>;
    const breadcrumbItems = this.props.items.map(function(item, i) {
      if (item.link && item.link != null) {
        const link = LanguageSupportUtil.wrapUrlSafe(item.link, this.props.context.languageRegionCode);
        return (
          <li className={item.class} key={`breadcrumb-${item.label}`}>
            {i > 0 && bullet}
            <a href={link}>{item.label}</a>
          </li>
        );
      }
      return (
        <li className={item.class} key={`breadcrumb-${item.label}`}>
          {i > 0 && bullet}
          {item.label}
        </li>
      );
    }.bind(this));
    return (
      <div>
        <div id="breadcrumb-bar">
          <AlgoliaSearchBox
            onMapPage={this.props.onMapPage}
            numResults={this.props.isMobileWidth ? 8 : 10}
            currentUser={this.props.context.currentUser}
            mobileBrowser={this.props.context.mobileBrowser}
            languageRegionCode={this.props.context.languageRegionCode}
            typeSubset={this.props.typeSubsets}
            page={EXPLORE}
            intl={this.props.intl}
          />
          <ul id="breadcrumb-list">{breadcrumbItems}</ul>
        </div>
      </div>
    );
  }
});

export { FullscreenBreadcrumbBar };
